import { render, staticRenderFns } from "./medical-analyses.vue?vue&type=template&id=2aff18a0&scoped=true&"
import script from "./medical-analyses.vue?vue&type=script&lang=js&"
export * from "./medical-analyses.vue?vue&type=script&lang=js&"
import style0 from "./medical-analyses.vue?vue&type=style&index=0&id=2aff18a0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aff18a0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/vue/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2aff18a0')) {
      api.createRecord('2aff18a0', component.options)
    } else {
      api.reload('2aff18a0', component.options)
    }
    module.hot.accept("./medical-analyses.vue?vue&type=template&id=2aff18a0&scoped=true&", function () {
      api.rerender('2aff18a0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/medical-analyses.vue"
export default component.exports